import { render, staticRenderFns } from "./MiscSettings.vue?vue&type=template&id=3dbcca68"
import script from "./MiscSettings.vue?vue&type=script&lang=ts"
export * from "./MiscSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3dbcca68')) {
      api.createRecord('3dbcca68', component.options)
    } else {
      api.reload('3dbcca68', component.options)
    }
    module.hot.accept("./MiscSettings.vue?vue&type=template&id=3dbcca68", function () {
      api.rerender('3dbcca68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/reportengine/MiscSettings.vue"
export default component.exports